import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Combos/getComboNumerosAlbaran`, method: 'GET', body: null})
}